import { render, staticRenderFns } from "./LakeService.vue?vue&type=template&id=b1359e84&"
import script from "./LakeService.vue?vue&type=script&lang=js&"
export * from "./LakeService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports